import {newEntityStoreHelper} from "@/store/common/entityModule";
 
export default newEntityStoreHelper(() => {}, () => {})
    .withStates({
        selectItems: [],
    })
    .withActions({
        retrieveForSelect(context) {
            var url = process.env.VUE_APP_MASTER_API_URL + "master-service/master/systemType/findAll"
            context.dispatch("api/get", {url}, {root: true})
            .then(function(data) {
                var result = data.map(x => { return {value: x.id, text: x.name} })
                context.commit("systemType/setSelectItens", result, {root: true})
            })
        }
    })
    .withMutations({
        setSelectItens(state, data) {
            state.selectItems = data
        }
    })
    .buildStore()